import { REDIECT_TAB } from "../actionTypes";

export const redirectTab = (value) => ({
    type: REDIECT_TAB,
    payload: value,
  });